<template>
  <div class="container reset-confirm-password-container">
    <header-links></header-links>
    <set-password-component
      v-if="!isTokenError && !confirmationStatus.success"
      :errors="confirmationStatus.errors['errors']"
      :success="confirmationStatus.success"
      :resetPassword="resetPassword"
      :password="confirmationStatus.password"
      :handleChangeField="handleChangeField"
    >
    </set-password-component>
    <reset-password-confirmation-component
      v-else
      :errors="resetErrors"
      :success="confirmationStatus.success"
    >
    </reset-password-confirmation-component>
  </div>
</template>

<script>

import HeaderLinks from '@/pages/reset-password/common/HeaderLinks';
import ResetPasswordConfirmationComponent from '@/pages/reset-password/confirmation/ResetPasswordConfirmationComponent';
import SetPasswordComponent from '@/pages/reset-password/confirmation/SetPasswordComponent';

export default {
  computed: {
    confirmationStatus() {
      return this.$store.getters.getPasswordResetConfirmationStatus;
    },
    resetErrors() {
      return this.$store.getters.getResetErrors;
    },
    isTokenError() {
      return (
        this.confirmationStatus &&
        this.confirmationStatus.errors &&
        this.confirmationStatus.errors['errors'] &&
        this.confirmationStatus.errors['errors']['token']
      );
    }
  },
  methods: {
    resetPassword() {
      this.$store.dispatch('resetPassword', {
        uid: this.$route.params.uid,
        token: this.$route.params.token,
        password: this.confirmationStatus.password
      });
    },
    handleChangeField(input) {
      this.$store.commit('newPasswordChange', input.target.value);
    }
  },
  components: {
    ResetPasswordConfirmationComponent,
    SetPasswordComponent,
    HeaderLinks
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.login-section {
  padding: 25px 15px;
  display: flex;
  justify-content: flex-end;
  font-size: 13px;

  a {
    color: var(--dark-gray);
    text-decoration: underline;
    margin: 10px;
  }
}

.reset-confirm-password-container {
  padding: 30px;
  height: auto;
  padding-left: 20px;
  padding-right: 20px;
}

@media screen and (min-width: $tablet) {
  .reset-confirm-password-container {
    height: 100vh;
  }
}
</style>
